import { useState } from 'react'

export type ResultWidth = 'normal' | 'wide' | 'full'

export const RESULT_WIDTH_LABELS: Record<ResultWidth, string> = {
  normal: 'Smal',
  wide:   'Breed',
  full:   'Vol',
}

// Alleen de breedtebeperking — overflow-auto hoort op de buitenste <main>, niet hier.
// Anders krimpt het scrollbare vlak mee met max-w/mx-auto en werkt het muiswiel niet meer
// in de marge links/rechts van de (gecentreerde) inhoud.
export const RESULT_WIDTH_CLASSES: Record<ResultWidth, string> = {
  normal: 'max-w-6xl mx-auto',
  wide:   'max-w-screen-2xl mx-auto',
  full:   '',
}

const RESULT_WIDTH_KEY = 'result_width_v1'

function loadResultWidth(): ResultWidth {
  const v = localStorage.getItem(RESULT_WIDTH_KEY)
  if (v === 'normal' || v === 'wide' || v === 'full') return v
  return 'full'
}

export function useResultWidth() {
  const [resultWidth, setResultWidthState] = useState<ResultWidth>(loadResultWidth)
  const setResultWidth = (w: ResultWidth) => {
    setResultWidthState(w)
    localStorage.setItem(RESULT_WIDTH_KEY, w)
  }
  return { resultWidth, setResultWidth }
}
